import { Step } from '@main/mobile-menu/const';

export const MOBILE_MENU_FEATURE = 'mobile-menu';

export interface MobileMenuData {
  steps: Step[];
  depth: number;
}

export interface StateWithMobileMenu {
  [MOBILE_MENU_FEATURE]: MobileMenuState;
}

export interface MobileMenuState {
  mobileMenu: MobileMenuData;
}
